<app-card label="Imaging">
  <dx-data-grid [dataSource]="documents" [hoverStateEnabled]="true" [paging]="{ pageSize: 10 }" [pager]="{ showPageSizeSelector: true, allowedPageSizes: [5, 10, 20], showInfo: true, showNavigationButtons: true }"
    [wordWrapEnabled]="true" [rowAlternationEnabled]="true" [showColumnLines]="false" [searchPanel]="{ visible: true, placeholder: 'Search...' }"
    (onRowClick)="onDocumentSelected($event.data)">

    <dxi-column dataField="documentDate" caption="Created Date" dataType="date" sortOrder="desc" width="100px"></dxi-column>
    <dxi-column dataField="itemName" caption="Document Type" [allowSorting]="false" [allowSearch]="true" cellTemplate="titleTemplate"></dxi-column>

    <div *dxTemplate="let document of 'titleTemplate'">
      <a (click)="onDocumentSelected(document.data)" class="dead-link">{{ document.data.itemName }}</a>
    </div>
  </dx-data-grid>
</app-card>
<router-outlet></router-outlet>
